import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/actionTypes';

import { removePhoto } from './utils';

export default function* listenRemovePhoto() {
  yield takeEvery(actionTypes.REMOVE_PHOTO, removePhoto);
}
